import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import SlideDownCard from '@ui/cards/slide-down-card/slide-down-card';
import SegmentedSwitch from './segmented-switch';
import ScaleSlider from './scale-slider';
import type { MediaWidgetSize } from '../../../templates/widgets/widget-types';

const SIZE_OPTIONS = [
  { value: 'original', label: 'Original' },
  { value: 'fill', label: 'Fill' },
  { value: 'scale', label: 'Scale' },
];

interface SizeControlProps {
  size: MediaWidgetSize;
  scale: number;
  onChangeSize: (value: MediaWidgetSize) => void;
  onChangeScale: (value: number | undefined) => void;
}

export default function SizeControl({ size, scale, onChangeSize, onChangeScale }: SizeControlProps) {
  return (
    <Container className="flex-column gap-8">
      <Container className="flex-column gap-8">
        <Text tag="label" design="GlobalIcoText3" className="L2 padding-l-16">
          Size
        </Text>
        <SegmentedSwitch
          fullWidth
          value={size}
          options={SIZE_OPTIONS}
          onChange={(value) => onChangeSize(value as MediaWidgetSize)}
        />
      </Container>

      <SlideDownCard open={size === 'scale'} autoGrow animateOnInitialLoad={false}>
        <ScaleSlider min={1} max={100} value={scale} onChange={onChangeScale} label="Scale" inputLabel="%" />
      </SlideDownCard>
    </Container>
  );
}
